import VerticalImageCarousel from "../../components/verticalCarousel";
import { Link } from "react-router-dom";

export default function EducationPage() {
  return (
    <div
      style={{
        backgroundImage:
          "url(https://static.igem.wiki/teams/4260/wiki/education/fondo-education.jpg)",
        minHeight: "100vh",
      }}
    >
      <div className="p-10 max-w-2xl m-auto pt-20 text-white">
        <h1 className="text-6xl text-center text-white font-bold">EDUCATION</h1>
      </div>

     

      <VerticalImageCarousel />
      
                <lable
                  className="btn text-lg mt-20 object-center justify-center content-center object-senter"
                  style={{
                    color: "black",
                    backgroundColor: "transparent",
                    borderColor: "black",
                  }}
                >
                  <a href = "https://static.igem.wiki/teams/4260/wiki/education/librocolorear.pdf">Download our coloring book!</a>
                </lable>

    </div>
  );
}
